import React from 'react';
import { PlumbingSalesPage } from './pages/PlumbingSalesPage';
export function App() {
  return <div className="w-full min-h-screen" data-id="element-0">
      <PlumbingSalesPage data-id="element-1" />
    </div>;
}